import { InquirerForm } from './InquirerForm';

export default InquirerForm;